import { Router, watchBusy } from "@frui.ts/screens/dist";
import { attachAutomaticValidator } from "@frui.ts/validation";
import type { interfaces } from "inversify";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import { Modules } from "config";
import BankAccountEnum, { BankAccountEnumValidationRules } from "entities/bankAccountEnum";
import EnumRepository from "repositories/enumRepository";
import OptionsService from "services/optionsService";
import SecurityService from "services/securityService";
import EditableDetailViewModel from "../../editableDetailViewModel";
import { BankAccountValidationRules } from "../../../entities/bankAccount";

@Router.registerRoute({ route: ":bankAccountId", name: Router.Self })
export default class BankAccountDetailViewModel extends EditableDetailViewModel<BankAccountEnum> {
  readonly modelName = "bankAccountEnum";

  constructor(
    protected itemId: string,
    private repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected eventBus: EventBus,
    protected securityService: SecurityService,
    protected optionsService: OptionsService
  ) {
    super(itemId);
  }

  @watchBusy
  protected async loadDetail() {
    const item = await this.repository.get<BankAccountEnum>(this.itemId, "bank_accounts", BankAccountEnum);
    attachAutomaticValidator(item, BankAccountEnumValidationRules);
    attachAutomaticValidator(item.bankAccount, BankAccountValidationRules);

    return item;
  }

  protected updateData() {
    return this.repository.update(this.item, "bank_accounts", BankAccountEnum);
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `bankAccounts.${code}`, size);
  }

  static Factory({ container }: interfaces.Context) {
    return (itemId: string) => {
      return new BankAccountDetailViewModel(
        itemId,
        container.get(EnumRepository),
        container.get(LocalizationService),
        container.get(NotificationService),
        container.get(EventBus),
        container.get(SecurityService),
        container.get(OptionsService)
      );
    };
  }
}
